var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AddStBaseApplicant',{attrs:{"add-statement":_vm.addStatement,"title":_vm.title},on:{"send":_vm.saveDraft},scopedSlots:_vm._u([{key:"footer",fn:function(ref){
var next = ref.next;
return [_c('div',[_vm._t("footer",null,{"next":next,"isSaveLoading":_vm.isSaveDraftLoading})],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }